
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import ReservierungBestaetigtLogic from "@/logic/bestellung_neu/reservierung_bestaetigt_logic"

@Component({ components: { FilialeHeader } })
export default class ReservierungBestaetigt extends mixins(Calculator) {
  logic: ReservierungBestaetigtLogic = new ReservierungBestaetigtLogic()
}
